import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';
import Cover from '../../Cover';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaFacebook, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const Contact = () => {
  const form = useRef();
  const [setError] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_m8q7a24', 'template_doyfnfq', form.current, {
        publicKey: '_xJg2TfZF7hIHM0qf',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          toast.success('Email Sent Successful');
          setError(false);
        },
        (error) => {
          console.log('FAILED...', error.text);
          setError(true);
        }
      );
  };
  const notify = () => toast('Email Sent Successful!');
  return (
    <Cover>
      <div
        className={`w-screen  flex items-center justify-center  `}
        id={'contact'}
      >
        <div className="w-[80%] mx-auto items-center justify-center mb-7  ">
          <div className=" flex lg:flex-row flex-col w-full h-full items-center  justify-between">
            <motion.div
              className=" flex flex-col gap-10 lg:flex-1 mb-3 "
              initial={{ x: -100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{
                delay: 0.1,
                x: { type: 'spring', stiffness: 100 },
                opacity: { duration: 0.8 },
                ease: 'easeIn',
                duration: 1,
              }}
            >
              <h1 className=" lg:text-[90px] text-[60px] font-bold leading-[60px] lg:leading-[88px]">
                Let's work together
              </h1>
              <div className="item">
                <h2 className=" font-extrabold">Mail</h2>
                <span className=" font-[300px]">okoid721@gmail.com</span>
              </div>

              <div className="item">
                <h2 className=" font-extrabold">Phone</h2>
                <span className=" font-[300px]">
                  <a href="https://wa.link/fwtols">+2349066587690</a>
                </span>
              </div>
              <div className="flex-row flex gap-3">
                <a
                  href="https://www.linkedin.com/in/okoi-david-6a01142a0/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaLinkedinIn size={30} />
                </a>
                <a
                  href="https://www.instagram.com/king_dave_offical/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaInstagram size={30} />
                </a>
                <a
                  href="https://web.facebook.com/agba.coder"
                  target="_blank"
                  rel="noreferrer"
                >
                  <FaFacebook size={30} />
                </a>
              </div>
            </motion.div>
            <motion.div
              className=" flex-1 "
              initial={{ x: 100, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{
                delay: 0.1,
                x: { type: 'spring', stiffness: 100 },
                opacity: { duration: 0.8 },
                ease: 'easeIn',
                duration: 1,
              }}
            >
              <form
                action=""
                className=" flex flex-col items-center gap-5"
                ref={form}
                onSubmit={sendEmail}
              >
                <input
                  type="text"
                  required
                  placeholder="Name"
                  name="name"
                  className=" py-[10px] px-7 lg:w-[400px] w-[350px] bg-transparent border-[1px] text-white rounded-[5px] border-white"
                />
                <input
                  type="email"
                  required
                  placeholder="Email"
                  name="email"
                  className=" py-[10px] px-7 lg:w-[400px] w-[350px] bg-transparent border-[1px]  text-white rounded-[5px] border-white"
                />
                <textarea
                  rows="10"
                  placeholder="Message"
                  name="message"
                  className="py-[10px] px-7 lg:w-[400px] w-[350px] bg-transparent border-[1px]  text-white rounded-[5px] border-white"
                />
                <button
                  onClick={notify}
                  type="submit"
                  className="py-[10px] px-7 lg:w-[400px] w-[350px] hover:bg-yellow-500 hover:border-none cursor-pointer font-bold bg-transparent border-[1px]  text-white rounded-[5px] border-white"
                >
                  Send
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </Cover>
  );
};

export default Contact;
